import config from 'config/config';
import { useModel } from 'umi';

export default function Footer() {
    const { config, configLoading } = useModel('global');   
    return (
        <footer>
            &copy; {config?.name}, 2025
            <p>
                {config?.data?.name}, ОГРН {config?.data?.ogrn}, ИНН {config?.data?.inn}
                <br/>
                {config?.data?.address}
            </p>
        </footer>
    );
}
